import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'localization';
import { LDUsers } from 'types';

import { LDList } from './components';

type LDTabProps = { lds: LDUsers; symbol: string | undefined };

const LDTab: React.FC<LDTabProps> = ({ lds, symbol }) => {
  const { t } = useTranslation('component.deposit.ld');

  return (
    <Box my={4} w="100%">
      <Text
        fontSize={{ base: 'md', lg: '2xl' }}
        py={2}
        px={{ base: 4, lg: 0 }}
        fontWeight="bold"
      >
        {t('title')}
      </Text>
      <VStack
        display="flex"
        w="100%"
        py={8}
        px={4}
        gap={25}
        bgColor="dark"
        align="flex-start"
      >
        <LDList lds={lds} symbol={symbol} />
      </VStack>
    </Box>
  );
};

export default LDTab;
